import { transport } from 'config/transport';

export function callApiTransferStudents(classId, body, toClass) {
    return transport.put(`/mamnon/classes/${classId}/students/transfer`, body, { params: { toClass } });
}
